import { Link } from "react-router-dom";

interface FeaturedPropertyCardProps {
  image: string;
  status?: string;
  price: string;
  priceNote?: string;
  address: string;
  beds?: number;
  baths?: number;
  sqft?: string;
  href?: string;
  logo?: string;
}

const FeaturedPropertyCard = ({
  image,
  status,
  price,
  priceNote,
  address,
  beds,
  baths,
  sqft,
  href,
  logo,
}: FeaturedPropertyCardProps) => {
  const Wrapper = href ? Link : "div";
  const wrapperProps = href ? { to: href } : {};

  return (
    <Wrapper
      {...(wrapperProps as any)}
      className="group block relative overflow-hidden bg-card border border-border transition-all duration-500 hover:border-accent/30 hover:shadow-[0_12px_40px_-12px_hsl(var(--accent)/0.12)]"
    >
      {/* Image */}
      <div className="relative aspect-[3/2] overflow-hidden">
        <img
          src={image}
          alt={address}
          className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
          loading="lazy"
        />

        {/* Status badge */}
        {status && (
          <span className="absolute top-5 left-5 bg-accent text-accent-foreground font-body text-[11px] uppercase tracking-[0.2em] px-4 py-2">
            {status}
          </span>
        )}

        {/* Logo watermark */}
        {logo && (
          <img
            src={logo}
            alt=""
            className="absolute bottom-4 right-4 h-6 w-auto opacity-60"
            loading="lazy"
          />
        )}

        {/* Gradient overlay on hover */}
        <div className="absolute inset-0 bg-gradient-to-t from-rich-black/40 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
      </div>

      {/* Content */}
      <div className="p-6 md:p-8">
        <p className="font-headline text-2xl md:text-3xl text-foreground mb-0.5">
          {price}
        </p>
        {priceNote && (
          <p className="font-body text-xs text-muted-foreground mb-1.5">{priceNote}</p>
        )}
        <p className="text-muted-foreground text-base leading-relaxed mb-5">
          {address}
        </p>

        {/* Details */}
        {(beds !== undefined || baths !== undefined || sqft) && (
          <div className="flex items-center gap-5 pt-5 border-t border-border">
            {beds !== undefined && (
              <span className="font-body text-sm uppercase tracking-widest text-muted-foreground">
                <strong className="text-foreground font-semibold">{beds}</strong> Beds
              </span>
            )}
            {baths !== undefined && (
              <span className="font-body text-sm uppercase tracking-widest text-muted-foreground">
                <strong className="text-foreground font-semibold">{baths}</strong> Baths
              </span>
            )}
            {sqft && (
              <span className="font-body text-sm uppercase tracking-widest text-muted-foreground">
                <strong className="text-foreground font-semibold">{sqft}</strong> Sqft
              </span>
            )}
          </div>
        )}
      </div>
    </Wrapper>
  );
};

export default FeaturedPropertyCard;
